import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import AppliedRoute from './AppliedRoute';

class AuthenticatedRoute extends Component {
  constructor (props) {
    super(props);

    this.state = {
      originalRoute: this.props.location
    };
  }

  userAuthenticated () {
    return Object.keys(this.props.user).length > 0;
  }

  componentDidMount () {
    if (this.userAuthenticated) {
      this.props.setRedirect(this.state.originalRoute);
    }
  }

  render () {
    return (
      this.userAuthenticated()
        ? <AppliedRoute exact {...this.props} component={this.props.component} />
        : <Redirect to='/login' />
    );
  }
}

function mapStateToProps (state) {
  return {
    user: state.authentication.user
  };
}

function mapDispatchToProps (dispatch) {
  return {
    setRedirect: redirect =>
      dispatch({
        type: 'SET_REDIRECT',
        redirect: redirect
      })
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthenticatedRoute);
